import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b11cd81&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=4b11cd81&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b11cd81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b11cd81')) {
      api.createRecord('4b11cd81', component.options)
    } else {
      api.reload('4b11cd81', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b11cd81&scoped=true", function () {
      api.rerender('4b11cd81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store-dashboard/index.vue"
export default component.exports